import { memo, useMemo } from "react";
import { UIMessage } from "ai";
import { Streamdown } from "streamdown";

import { Group, Paper, Text } from "@mantine/core";

import MentionText from "modules/core/components/MentionTextInput/MentionText";

import { IRollupProject } from "modules/projects/types/entities";

import classes from "./styles.module.css";

import "streamdown/styles.css";

type TextMessageProps = {
  text: string;
  role: UIMessage["role"];
  projects: IRollupProject[];
};

const TextMessage = (props: TextMessageProps) => {
  const { text, role, projects } = props;

  const projectOptions = useMemo(() => {
    return projects.map(project => ({
      label: project.name,
      id: project.id
    }));
  }, [projects]);

  if (role === "system") return null;

  return (
    <Group justify={role === "user" ? "end" : "start"}>
      <Paper
        bg={role === "user" ? "dark" : "transparent"}
        c={role === "user" ? "white" : "dark"}
        py="xs"
        px="md"
        radius="xl"
        w="fit-content"
        ml={role === "user" ? "auto" : 0}
      >
        {role === "assistant" ? (
          <Streamdown animated caret="block">
            {text}
          </Streamdown>
        ) : (
          <Text fz="sm">
            <MentionText
              value={text}
              mentions={projectOptions}
              mask="@Project[__label__](__id__)"
              mentionClassName={classes.mention}
            />
          </Text>
        )}
      </Paper>
    </Group>
  );
};

export default memo(TextMessage);
